import { render } from "./CategoryListComponent.vue?vue&type=template&id=f264f016"
import script from "./CategoryListComponent.vue?vue&type=script&lang=js"
export * from "./CategoryListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__